import { isArray, compact } from 'lodash/fp';
import compactObject from './compactObject';
export var clearFalsy = function clearFalsy(value) {
  var clearFunc = isArray(value) ? compact : compactObject;
  return clearFunc(value);
};
export default clearFalsy;